import http from '@/api/HttpHelper'
import moment from 'moment'

const findYears = function () {
    const startYear = 2014
    const yearNow = moment().year()
    const years = []

    for (let year = yearNow; year >= startYear; year--) {
        years.push(year)
    }

    return years
}

const state = {
    customers: [],
    exportFormats: [],
    years: findYears()
}

const getters = {
    customers (state) {
        return state.customers
    },
    exportFormats (state) {
        return state.exportFormats
    },
    years (state) {
        return state.years
    }
}

const mutations = {
    setCustomers (state, customers) {
        state.customers = customers
    },
    setExportFormats (state, exportFormats) {
        state.exportFormats = exportFormats
    }
}

const actions = {
    async getCustomers ({ commit }) {
        var result = await http.get('emailAdmin?companyId=')
        if (result.status === 200)
            commit('setCustomers', result.data)
    },
    async saveEmailSettings ({ dispatch }, emailSettings) {
        await http.post('emailAdmin', emailSettings)
        dispatch('getCustomers')
    },
    async deleteEmailSetting ({ dispatch }, emailSettings) {
        await http.delete(`emailAdmin/${emailSettings.partitionKey}/${emailSettings.rowKey}`)
        dispatch('getCustomers')
    },
    async getExportFormats ({ commit }) {
        var result = await http.get('productmapping/exportformats')
        if (result.status === 200)
            commit('setExportFormats', result.data)
    },
    async sendEmailReport (_, emailReportSettings) {
        await http.put('emailAdmin', emailReportSettings)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}